import { api } from "./client";
import type { PortalNotificationType } from "./adminNotifications";

// Portal-absorption spine (WS-C0) — staff reads for the per-party portal
// tabs. The per-account notifications feed mirrors the recipient's own
// portal feed (same projection), read via the admin surface.
// (No React Query here — that lives in hooks/portalAbsorption.)

export interface AccountNotificationFeedItem {
  id: string;
  title: string;
  body: string;
  type: PortalNotificationType;
  createdAt: string;
  readAt: string | null;
  /** Display name of the staff sender. Optional — older API builds omit it. */
  createdByUserName?: string | null;
  /** Whether the notification also went out as an email. Optional — older API builds omit it. */
  sentEmail?: boolean;
}

export const portalAbsorptionApi = {
  notificationsForAccount: (portalUserId: string) =>
    api.get<AccountNotificationFeedItem[]>(
      `/admin/notifications/by-account/${portalUserId}`,
    ),
};
